// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"684":"87f5f0d8","965":"87f5f0d8"}[chunkId] + ".chunk.css";
};